export default __webpack_public_path__ + "static/media/avatar_115.a869e9de.png";